import Quote from "@components/quotes";
import FoxHomeLogo from "@components/foxHomeLogo";
import {TextStyle} from "@shopify/polaris";
import { useEffect } from "react";
import '@styles/users.scss'

const UserLayout = ({children, title, showQuote = false}) => {
  useEffect(() => {
    document.title = `${title} - FoxHome`;
    document.body.classList.add('user-page');
  }, []);

	return (
		<div className={'User-Layout'}>
      <main className={'User-Layout__wrapper'}>
        <FoxHomeLogo />
        <div className="User-Layout__content">
          {children}
        </div>
        <div className="User-Layout__footer">
            <TextStyle>Copyright &copy; 2023 FoxEcom. All Rights Reserved.</TextStyle>
            <div className={'flex'}>
              <a href="https://docs.foxecom.com/minimog-theme/foxhome/what-is-foxhome" target={'_blank'}>What's FoxHome?</a>
              <a href="https://foxecom.com/pages/privacy-policy" target={'_blank'}>Privacy Policy</a>
              <a href="https://foxecom.com/pages/terms-of-service" target={'_blank'}>Terms of Use</a>
            </div>
        </div>
      </main>
      {showQuote && <div className="User-Layout__quote-placeholder" />}
      {showQuote && <div className="User-Layout__quote">
        <img src={'https://cdn.shopify.com/s/files/1/0594/4190/5837/files/user-bg.jpg'} alt="Customers say"/>
        <Quote/>
      </div>}
		</div>
	)
}

export default UserLayout
